<template>
  <div id="page" :class="[isLight ? 'lightmode' : 'darkmode']">
    <div v-if="isMenuShown" class="darker-film" @click="toggleMenuMobile"></div>
    <div v-if="isTimezoneMenuShown" class="darker-film" @click="toggleTimezoneMenu"></div>
    <sidebar-navigator @change-theme="changeTheme" 
                       @toggle-menu-mobile="toggleMenuMobile" 
                       @change-calc="changeCalc" 
                       :menu-shown="isMenuShown"
                       :dark-mode="isLight"
                       :selected-calc="selectedCalc"/>
    <navigation-bar @toggle-menu-mobile="toggleMenuMobile" @change-theme="changeTheme" :dark-mode="isLight"/>
    <timezone-calculator v-if="selectedCalc === 3" :dark-mode="isLight" @open-timezone-menu="openTimezoneMenu" @set-timezone-index="setTimezoneIndex" :timezone-from="timezoneFromIndex" :timezone-to="timezoneToIndex"/>
    <div v-if="isTimezoneMenuShown" id="timezone-menu" :class="[isLight ? 'lightmode' : 'darkmode']">
      <div v-for="(name,index) in timezoneCities" :key="index" @click="() => timezoneMenuSelection(index)">
        <p :class="[isLight ? 'lightmode' : 'darkmode']">{{ timezoneNames[index] }}</p><p :class="[isLight ? 'lightmode' : 'darkmode']">{{ name }}</p>
      </div>
    </div>
    <info-footer />
  </div>
</template>

<script setup>
  import { ref,computed,onMounted, onUnmounted } from "vue";
  import SidebarNavigator from "./SidebarNavigator.vue";
  import InfoFooter from "./InfoFooter.vue";
  import TimezoneCalculator from "./TimezoneCalculator.vue";
  import NavigationBar from "./NavigationBar.vue";
  import { timeCalculatorSettings } from "@/stores/TimeCalculatorStore";

  var isLight = computed(() => timeCalculatorSettings().lightMode);
  var isMenuShown = ref(false);
  var selectedCalc = ref(3);

  const changeTheme = () =>
  {
    timeCalculatorSettings().changeTheme();
  }

  const toggleMenuMobile = () =>
  {
    isMenuShown.value = !isMenuShown.value;
    
    if(isMenuShown.value)
    {
      document.body.classList.add('menu-shown');
    }

    else
    {
      document.body.classList.remove('menu-shown');
    }
  }

  const changeToDesktop = () =>
  {
    if (window.innerWidth > 770) 
    {
        isMenuShown.value = false;
        document.body.classList.remove('menu-shown');
    }
  }

  onMounted(() => 
  {
    changeToDesktop();
    window.addEventListener('resize',changeToDesktop);
    document.body.classList.remove('menu-shown');
  });

  onUnmounted(() =>
  {
    window.removeEventListener('resize',changeToDesktop);
    document.body.classList.remove('menu-shown');
  });

  var isTimezoneMenuShown = ref(false);
  var timezoneFromIndex = ref(13);
  var timezoneToIndex = ref(13);
  var timezoneToMenu = ref(false);
  var timezoneFromMenu = ref(false);
  var timezoneCities = ref([]);
  var timezoneNames = ref([]);

  const toggleTimezoneMenu = () =>
  {
    isTimezoneMenuShown.value = !isTimezoneMenuShown.value;
  }

  const openTimezoneMenu = (a,b,c,d) =>
  {
    isTimezoneMenuShown.value = !isTimezoneMenuShown.value;
    timezoneCities.value = b;
    timezoneNames.value = a;
    timezoneFromMenu.value = c;
    timezoneToMenu.value = d;
  }

  const timezoneMenuSelection = (a) =>
  {
    if(timezoneFromMenu.value) 
    {
      timezoneFromIndex.value = a;
      if(timezoneFromIndex.value >= 35 && timezoneToIndex.value < 35) timezoneToIndex.value += 35;
      else if(timezoneFromIndex.value < 35 && timezoneToIndex.value >= 35) timezoneToIndex.value -= 35;
    }

    else timezoneToIndex.value = a;

    isTimezoneMenuShown.value = false;
  }

  const setTimezoneIndex = (a) =>
  {
    timezoneFromIndex.value = a;
  }
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Syne');
  #page
  {
    display: grid;
    min-height:100dvh;
    width:100vw;
    padding:0;
    margin:0;
    grid-template-columns: 1fr;
    grid-template-rows:67px 1fr 50px;
  }

  #page.lightmode
  {
    background-color: #F0F0F0;
  }

  #page.darkmode
  {
    background-color: #2b3133;
  }

  .darker-film
  {
    grid-area: 1 / 1 / -1 / 2;
    z-index:7;
    background-color: rgba(128, 128, 128, 0.4);
    transition: 0.1s all;
  }

  #timezone-menu
  {
    grid-area: 1 / 1 / -1 / 2;
    justify-self: center;
    align-self: flex-start;
    margin-top:4%;
    width:90%;
    height:90dvh;
    overflow-y: scroll;
    border:2px solid #2b3133;
    font-family: Syne;
    border-radius: 12px;
    padding:2px 5px;
    z-index: 10;
    -ms-overflow-style: none;
    scrollbar-width: none;
    user-select: none;
  }

  #timezone-menu::-webkit-scrollbar
  {
    display: none;
  }

  #timezone-menu.lightmode
  {
    background-color: #F7F7F6;
    color: #2b3133;
  }

  #timezone-menu.darkmode
  {
    background-color: #2b3133;
    color:#F7F7F6;
    border-color: #141718;
  }

  #timezone-menu > div
  {
    display: flex;
    cursor: pointer;
  }

  #timezone-menu > div:hover
  {
    background-color: #b3b9b3;
    color:#2b3133;
  }

  #timezone-menu > div > p
  {
    padding:0 5px;
  }

  #timezone-menu > div > p:first-child
  {
    width:33.333%;
    border-right: 1px solid;
    font-size: 18px;
    font-weight: bold;
  }

  #timezone-menu > div > p:last-child
  {
    width: 66.66666%;
    border-left: 1px solid;
    font-size: 17px;
  }

  #timezone-menu > div > p:first-child.lightmode
  {
    border-right-color: #2b3133;
  }

  #timezone-menu > div > p:last-child.lightmode
  {
    border-left-color: #2b3133;
  }

  #timezone-menu > div > p:first-child.darkmode
  {
    border-right-color: #F7F7F6;
  }

  #timezone-menu > div > p:last-child.darkmode
  {
    border-left-color: #F7F7F6;
  }

  @media screen and (min-width: 770px)
  {
    #page
    {
      width: 100vw;
      grid-template-columns: 100vw;
    }
  }
</style>
